import {Injectable, Injector} from "@angular/core";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {SellableData} from "./sellable.data";

@Injectable()
export class SellableEntityModel extends EntityModel<SellableData> {
    constructor(injector: Injector) {
        super(injector, SellableData);
    }
}
